module.exports = __webpack_public_path__ + "img/avatar-15.3e422eb2.png";